export enum DiscoveryPropertySettingState {
    Disabled = 0,
    Preview = 1,
    Published = 2,
    Hidden = 3,
    FliptoOnly = 4
}
